import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Query = {
  __typename?: 'Query';
  _: Scalars['String'];
  getPortfolio: Portfolio;
  getMyPortfolio: Portfolio;
  getUsers: Array<User>;
  getMe?: Maybe<User>;
  getMyModules: Array<Module>;
  getAvailableModules?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetPortfolioArgs = {
  id: Scalars['ID'];
};

export type Portfolio = {
  __typename?: 'Portfolio';
  id: Scalars['String'];
  for: Scalars['String'];
  knownAs: Array<Scalars['String']>;
  socialLinks?: Maybe<PortfolioSocialLinks>;
  about?: Maybe<PortfolioAbout>;
  resume?: Maybe<PortfolioResume>;
  projects?: Maybe<Array<PortfolioProject>>;
  map?: Maybe<PortfolioMap>;
  createdBy: User;
};

export type PortfolioSocialLinks = {
  __typename?: 'PortfolioSocialLinks';
  facebook: Scalars['String'];
  twitter: Scalars['String'];
  github: Scalars['String'];
  linkedin: Scalars['String'];
  stackOverflow: Scalars['String'];
};

export type PortfolioAbout = {
  __typename?: 'PortfolioAbout';
  title: Scalars['String'];
  description: Scalars['String'];
  hireMeLinks?: Maybe<PortfolioAboutLinks>;
  services?: Maybe<Array<PortfolioService>>;
};

export type PortfolioAboutLinks = {
  __typename?: 'PortfolioAboutLinks';
  fiverr: Scalars['String'];
  upwork: Scalars['String'];
};

export type PortfolioService = {
  __typename?: 'PortfolioService';
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type PortfolioResume = {
  __typename?: 'PortfolioResume';
  educations: Array<PortfolioResumeEducation>;
  experiences: Array<PortfolioResumeExperience>;
};

export type PortfolioResumeEducation = {
  __typename?: 'PortfolioResumeEducation';
  id: Scalars['ID'];
  institute: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  location: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type PortfolioResumeExperience = {
  __typename?: 'PortfolioResumeExperience';
  id: Scalars['ID'];
  designation: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  company: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type PortfolioProject = {
  __typename?: 'PortfolioProject';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  github: Scalars['String'];
  demo: Scalars['String'];
  tags: Array<Scalars['String']>;
  images: PortfolioProjectImg;
};

export type PortfolioProjectImg = {
  __typename?: 'PortfolioProjectImg';
  thumbnailImg: Scalars['String'];
  coverImg: Scalars['String'];
  screenshots: Array<Scalars['String']>;
};

export type PortfolioMap = {
  __typename?: 'PortfolioMap';
  latitude: Scalars['String'];
  longitude: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  provider: LoginProvidersEnum;
  status: LoginStatusEnum;
  role: LoginRoleEnum;
};

export enum LoginProvidersEnum {
  Email = 'EMAIL'
}

export enum LoginStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum LoginRoleEnum {
  Admin = 'ADMIN',
  User = 'USER'
}

export type Module = {
  __typename?: 'Module';
  id: Scalars['ID'];
  name: ModuleTypeEnum;
  createdBy: User;
};

export enum ModuleTypeEnum {
  Portfolio = 'PORTFOLIO'
}

export type Mutation = {
  __typename?: 'Mutation';
  _: Scalars['String'];
  createPortfolioModule: Portfolio;
  updatePortfolio: Portfolio;
  updateAboutPortfolio: Portfolio;
  updateMapPortfolio: Portfolio;
  updateSocialLinksPortfolio: Portfolio;
  updateAboutLinksPortfolio: Portfolio;
  createServicePortfolio: Portfolio;
  updateServicePortfolio: Portfolio;
  deleteServicePortfolio: Portfolio;
  createPortfolioEducation: Portfolio;
  updatePortfolioEducation: Portfolio;
  deletePortfolioEducation: Portfolio;
  createPortfolioExperience: Portfolio;
  updatePortfolioExperience: Portfolio;
  deletePortfolioExperience: Portfolio;
  createPortfolioProject: Portfolio;
  updatePortfolioProject: Portfolio;
  deletePortfolioProject: Portfolio;
  createUser: User;
  changeUserStatus: User;
  changeUserRole: User;
  deleteUser: User;
  updateProfile: User;
  loginWithEmail: EmailLoginResponse;
  uploadFile: Scalars['String'];
};


export type MutationCreatePortfolioModuleArgs = {
  input: PortfolioModuleInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdateAboutPortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdateMapPortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdateSocialLinksPortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdateAboutLinksPortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationCreateServicePortfolioArgs = {
  input: CreateServiceInput;
};


export type MutationUpdateServicePortfolioArgs = {
  input: UpdateServiceInput;
};


export type MutationDeleteServicePortfolioArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePortfolioEducationArgs = {
  input: CreateEducationInput;
};


export type MutationUpdatePortfolioEducationArgs = {
  input: UpdateEducationInput;
};


export type MutationDeletePortfolioEducationArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePortfolioExperienceArgs = {
  input: CreateExperienceInput;
};


export type MutationUpdatePortfolioExperienceArgs = {
  input: UpdateExperienceInput;
};


export type MutationDeletePortfolioExperienceArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePortfolioProjectArgs = {
  input: CreateProjectInput;
};


export type MutationUpdatePortfolioProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationDeletePortfolioProjectArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationChangeUserStatusArgs = {
  id: Scalars['ID'];
  status: LoginStatusEnum;
};


export type MutationChangeUserRoleArgs = {
  id: Scalars['ID'];
  access: LoginRoleEnum;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationLoginWithEmailArgs = {
  input: EmailLoginInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
};

export type PortfolioModuleInput = {
  for: Scalars['String'];
  knownAs: Array<Scalars['String']>;
  aboutTitle: Scalars['String'];
  aboutDesc: Scalars['String'];
};

export type UpdatePortfolioInput = {
  propertyName: Scalars['String'];
  propertyValue: Scalars['String'];
};

export type CreateServiceInput = {
  title: Scalars['String'];
  description: Scalars['String'];
};

export type UpdateServiceInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type CreateEducationInput = {
  institute: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type UpdateEducationInput = {
  id: Scalars['ID'];
  institute: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type CreateExperienceInput = {
  designation: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type UpdateExperienceInput = {
  id: Scalars['ID'];
  designation: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type CreateProjectInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  github: Scalars['String'];
  demo: Scalars['String'];
  tags: Array<Scalars['String']>;
  thumbnailImage: Scalars['String'];
};

export type UpdateProjectInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  github: Scalars['String'];
  demo: Scalars['String'];
  tags: Array<Scalars['String']>;
  thumbnailImage: Scalars['String'];
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  provider: LoginProvidersEnum;
  status: LoginStatusEnum;
  role: LoginRoleEnum;
};

export type UpdateProfileInput = {
  propertyName: Scalars['String'];
  propertyValue: Scalars['String'];
};

export type EmailLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type EmailLoginResponse = {
  __typename?: 'EmailLoginResponse';
  user: User;
  accessToken: Scalars['String'];
};


export type Subscription = {
  __typename?: 'Subscription';
  _: Scalars['String'];
  getMyPortfolioSub: Portfolio;
  getUsers: Array<User>;
};

export type PortfolioFragmentFragment = (
  { __typename?: 'Portfolio' }
  & Pick<Portfolio, 'id' | 'for' | 'knownAs'>
  & { socialLinks?: Maybe<(
    { __typename?: 'PortfolioSocialLinks' }
    & Pick<PortfolioSocialLinks, 'facebook' | 'twitter' | 'github' | 'linkedin' | 'stackOverflow'>
  )>, about?: Maybe<(
    { __typename?: 'PortfolioAbout' }
    & Pick<PortfolioAbout, 'title' | 'description'>
    & { hireMeLinks?: Maybe<(
      { __typename?: 'PortfolioAboutLinks' }
      & Pick<PortfolioAboutLinks, 'fiverr' | 'upwork'>
    )>, services?: Maybe<Array<(
      { __typename?: 'PortfolioService' }
      & Pick<PortfolioService, 'id' | 'title' | 'description'>
    )>> }
  )>, resume?: Maybe<(
    { __typename?: 'PortfolioResume' }
    & { educations: Array<(
      { __typename?: 'PortfolioResumeEducation' }
      & Pick<PortfolioResumeEducation, 'id' | 'institute' | 'startDate' | 'endDate' | 'location' | 'description'>
    )>, experiences: Array<(
      { __typename?: 'PortfolioResumeExperience' }
      & Pick<PortfolioResumeExperience, 'id' | 'designation' | 'startDate' | 'endDate' | 'company' | 'description'>
    )> }
  )>, projects?: Maybe<Array<(
    { __typename?: 'PortfolioProject' }
    & Pick<PortfolioProject, 'id' | 'name' | 'description' | 'github' | 'demo' | 'tags'>
    & { images: (
      { __typename?: 'PortfolioProjectImg' }
      & Pick<PortfolioProjectImg, 'thumbnailImg' | 'coverImg' | 'screenshots'>
    ) }
  )>>, map?: Maybe<(
    { __typename?: 'PortfolioMap' }
    & Pick<PortfolioMap, 'latitude' | 'longitude'>
  )> }
);

export type GetPortfolioQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPortfolioQuery = (
  { __typename?: 'Query' }
  & { getPortfolio: (
    { __typename?: 'Portfolio' }
    & PortfolioFragmentFragment
  ) }
);

export const PortfolioFragmentFragmentDoc = gql`
    fragment PortfolioFragment on Portfolio {
  id
  for
  knownAs
  socialLinks {
    facebook
    twitter
    github
    linkedin
    stackOverflow
  }
  about {
    title
    description
    hireMeLinks {
      fiverr
      upwork
    }
    services {
      id
      title
      description
    }
  }
  resume {
    educations {
      id
      institute
      startDate
      endDate
      location
      description
    }
    experiences {
      id
      designation
      startDate
      endDate
      company
      description
    }
  }
  projects {
    id
    name
    description
    github
    demo
    tags
    images {
      thumbnailImg
      coverImg
      screenshots
    }
  }
  map {
    latitude
    longitude
  }
}
    `;
export const GetPortfolioDocument = gql`
    query GetPortfolio($id: ID!) {
  getPortfolio(id: $id) {
    ...PortfolioFragment
  }
}
    ${PortfolioFragmentFragmentDoc}`;

/**
 * __useGetPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPortfolioQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>) {
        return Apollo.useQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, baseOptions);
      }
export function useGetPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>) {
          return Apollo.useLazyQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, baseOptions);
        }
export type GetPortfolioQueryHookResult = ReturnType<typeof useGetPortfolioQuery>;
export type GetPortfolioLazyQueryHookResult = ReturnType<typeof useGetPortfolioLazyQuery>;
export type GetPortfolioQueryResult = Apollo.QueryResult<GetPortfolioQuery, GetPortfolioQueryVariables>;